import { createTheme, Button, Badge, Text, colorsTuple } from '@mantine/core';
import ButtonStyle from './Button.module.css';
import BadgeStyle from './Badge.module.css';
export const theme = createTheme({
  colors: {
    'primary-light': colorsTuple('#136cb4'),
    'primary-dark': colorsTuple('#4ba4ec'),
    'secondary-light': colorsTuple('#2a547d'),
    'secondary-dark': colorsTuple('#abcced'),
    'accent-light': colorsTuple('#8ec64e'),
    'accent-dark': colorsTuple('#79b139'),
    'green-light': colorsTuple('#006400'),
    'green-dark': colorsTuple('#008000'),
    'gray-light': colorsTuple('#323232'),
    'gray-dark': colorsTuple('#efefef'),
    'red-dark': colorsTuple('#ff4347'),
    'red-light': colorsTuple('#a40e11'),
    'error-red-dark': colorsTuple('#ff434726'),
    'error-red-light': colorsTuple('#a40e114d'),
    'warning-yellow-dark': colorsTuple('#ffc107'),
    'warning-yellow-light': colorsTuple('#b08900'),
    'login-gradient-start': colorsTuple('#22d3ee'),
    'login-gradient-end': colorsTuple('#34d399'),
    'login-gradient-shadow': colorsTuple('rgba(52, 211, 153, 0.25)'),
    'surface-light': colorsTuple('#f8f9fa'),
    'surface-dark': colorsTuple('#2e2e2e'),
    'surface-elevated-light': colorsTuple('#ffffff'),
    'surface-elevated-dark': colorsTuple('#242424'),
    'border-light': colorsTuple('#dee2e6'),
    'border-dark': colorsTuple('#424242'),
    'gradient-light': colorsTuple(
      'linear-gradient(90deg, #fffff 0%, #dae3ea 100%)'
    ),
    'purple-light': colorsTuple('#a205f0'),
    'purple-dark': colorsTuple('#620391'),
    'gradient-dark': colorsTuple('linear-gradient(90deg, #111 0%, #555 100%)'),
    'tariff-modifier-light': colorsTuple('#D97706'),
    'tariff-modifier-dark': colorsTuple('#FDBA74'),
    'tariff-icd9-light': colorsTuple('#6a781a'),
    'tariff-icd9-dark': colorsTuple('#dfec96'),
  },
  components: {
    Button: Button.extend({
      defaultProps: {
        color: 'blue.6',
        variant: 'outline',
        radius: 'md',
      },
      classNames: {
        root: ButtonStyle.root,
      },
    }),
    Badge: Badge.extend({
      defaultProps: {
        color: 'cyan.6',
        variant: 'filled',
        size: 'md',
        radius: 'lg',
        opacity: 0.8,
      },
      classNames: {
        root: BadgeStyle.root,
      },
    }),
    Text: Text.extend({
      defaultProps: {
        size: 'md',
        c: 'black.6',
        fw: 500,
      },
    }),
  },
  primaryColor: 'blue',
  primaryShade: 7,
});
